var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import sort, { ESortOrder, dateSort, stringSort_depricated, } from "@domains/utils/sort";
export var applyInsiderSorting = function (data, sortingType, insiderData) {
    data.data = insiderData;
    var insiderDetails;
    if (sortingType.sortName == "clientName" ||
        sortingType.sortName == "discriptionName") {
        insiderDetails = stringSort_depricated(data.data, sortingType.sortName, sortingType.order);
    }
    else if (sortingType.sortName == "reportDate") {
        insiderDetails = dateSort(data.data, sortingType.sortName, sortingType.order);
    }
    else {
        insiderDetails = sort(data.data, sortingType.sortName, sortingType.order);
    }
    data.data = insiderDetails;
    data.sortState.map(function (e) { return (__assign(__assign({}, e), { order: sortingType.sortName === e.sortName
            ? sortingType.order
            : ESortOrder.UNCHANGED })); });
    return data;
};
